import React from 'react';

export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-6" data-testid={testid}>
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, description, action }) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed bg-white/60 py-16 px-6 text-center">
      {Icon && <Icon className="h-10 w-10 text-muted-foreground mb-3" />}
      <p className="font-medium">{title}</p>
      {description && <p className="text-sm text-muted-foreground mt-1 max-w-sm">{description}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function StatusBadge({ kind, value }) {
  const map = {
    stock: { ok: 'bg-emerald-50 text-emerald-700 border-emerald-200', low: 'bg-amber-50 text-amber-800 border-amber-200', out: 'bg-red-50 text-red-700 border-red-200' },
    payment: { Paid: 'bg-emerald-50 text-emerald-700 border-emerald-200', 'Partially Paid': 'bg-blue-50 text-blue-700 border-blue-200', Unpaid: 'bg-slate-100 text-slate-700 border-slate-200' },
    request: { approved: 'bg-emerald-50 text-emerald-700 border-emerald-200', pending: 'bg-amber-50 text-amber-800 border-amber-200', rejected: 'bg-red-50 text-red-700 border-red-200' },
    commission: { paid: 'bg-emerald-50 text-emerald-700 border-emerald-200', earned: 'bg-teal-50 text-teal-800 border-teal-200', pending: 'bg-slate-100 text-slate-700 border-slate-200', reversed: 'bg-red-50 text-red-700 border-red-200', none: 'bg-slate-100 text-slate-500 border-slate-200' },
  };
  const labels = { ok: 'In Stock', low: 'Low', out: 'Out' };
  const cls = (map[kind] && map[kind][value]) || 'bg-slate-100 text-slate-700 border-slate-200';
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize ${cls}`}>{labels[value] || value}</span>;
}
